import { ReactNode, useEffect, useState } from "react";
import { clsx } from "clsx";

import { ANIMATION_DELAY, CLOSE_TIMEOUT } from "../../config/config";
import { AlertTheme } from "../../const/const";
import { AlertOptions } from "../../model/types/alert";

import { useDevice } from "@/shared/lib/hooks/useDevice";
import { Icon } from "@/shared/ui/Icon";

import successIcon from "@/shared/assets/icons/check.svg";
import warningIcon from "@/shared/assets/icons/warning.svg";

import cls from "./Alert.module.scss";

export interface AlertProps {
  children: ReactNode;
  data: AlertOptions;
  onHide: () => void;
}

export const Alert = (props: AlertProps) => {
  const { children, data, onHide } = props;

  const { isSmallScreen } = useDevice();

  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const visibilityTimer = setTimeout(() => {
      setIsVisible(true);
    }, 10);

    const closeTimer = setTimeout(() => {
      setIsClosing(true);
    }, CLOSE_TIMEOUT);

    const animateDelayTimer = setTimeout(() => {
      setIsClosing(false);

      onHide();
    }, CLOSE_TIMEOUT + ANIMATION_DELAY);

    return () => {
      clearTimeout(visibilityTimer);
      clearTimeout(closeTimer);
      clearTimeout(animateDelayTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mods = {
    [cls[data.theme]]: true,
    [cls.isVisible]: isVisible,
    [cls.isClosing]: isClosing,
    [cls.isMobile]: isSmallScreen,
  };

  return (
    <div className={clsx(cls.Alert, mods, [data.className])}>
      <Icon
        className={cls.Icon}
        Svg={data.theme === AlertTheme.SUCCESS ? successIcon : warningIcon}
        width={24}
        height={24}
      />
      {children}
    </div>
  );
};
